/**
 * The organisation types of PRD §5.7, in filter order.
 *
 * STARTUP and CUSTOMER first because they carry the org link and account for
 * nearly every row; the three unaffiliated kinds follow.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.5, PRD §5.7
 */
import type { OrgType } from '@nexus/contracts';

export const ORG_TYPES: readonly OrgType[] = [
  'STARTUP',
  'CUSTOMER',
  'INTERNAL',
  'ADVISOR',
  'INVESTOR',
] as const;
